/* eslint-disable no-undef */
/* eslint-disable radix */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { comparatorQtr } from '../../../../../SharedModules/utilities/utilities';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
export const GenerateInvoiceTableHead = [
  {
    headerName: 'Actions',
    field: 'action',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: false,
    resizable: true,
    maxWidth: Styles.Width_100,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Sort Key',
    field: 'cfSortKey',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_120,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_130,
    comparator: comparatorQtr,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Number',
    field: 'invoiceNum',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'InvoiceNumberRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Mfg ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Print Image',
    field: 'printImageInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'PrintImageIndCheckBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    fillBackgroundColorCol: 'cfPrintImage',
    showBackgroundColor: true,
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.cfPrintImage?.toString() === '16756655',
      'yellow-legend': (params) =>
        params.data?.cfPrintImage?.toString() === '11534335',
      'pink-legend': (params) =>
        params.data?.cfPrintImage?.toString() === '11513855',
      'white-legend': (params) =>
        params.data?.cfPrintImage?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.cfPrintImage?.toString() === '12632256',
    },
  },
  {
    headerName: 'Print Paper',
    cellClass: 'frr-svg-checkbox',
    field: 'defPaperInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'DefPaperIndCheckBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    fillBackgroundColorCol: 'cfPrint',
    showBackgroundColor: true,
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.cfPrint?.toString() === '16756655',
      'yellow-legend': (params) =>
        params.data?.cfPrint?.toString() === '11534335',
      'pink-legend': (params) =>
        params.data?.cfPrint?.toString() === '11513855',
      'white-legend': (params) =>
        params.data?.cfPrint?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.cfPrint?.toString() === '12632256',
    },
  },

  {
    headerName: 'Printed',
    field: 'invoicePrintedDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_130,
    comparator: dateComparator,
    cellRenderer: 'PrintedDatePickerRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CMS Electronic',
    field: 'defCmsElectInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'DefCmsElectIndCheckBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    fillBackgroundColorCol: 'cfCmsElect',
    showBackgroundColor: true,
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.cfCmsElect?.toString() === '16756655',
      'yellow-legend': (params) =>
        params.data?.cfCmsElect?.toString() === '11534335',
      'pink-legend': (params) =>
        params.data?.cfCmsElect?.toString() === '11513855',
      'white-legend': (params) =>
        params.data?.cfCmsElect?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.cfCmsElect?.toString() === '12632256',
    },
  },
  {
    headerName: 'NCPDP Summary',
    field: 'defNcpdpSummaryInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'DefNcpdpSummaryIndCheckBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    fillBackgroundColorCol: 'cfNcpdpSumm',
    showBackgroundColor: true,
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.cfNcpdpSumm?.toString() === '16756655',
      'yellow-legend': (params) =>
        params.data?.cfNcpdpSumm?.toString() === '11534335',
      'pink-legend': (params) =>
        params.data?.cfNcpdpSumm?.toString() === '11513855',
      'white-legend': (params) =>
        params.data?.cfNcpdpSumm?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.cfNcpdpSumm?.toString() === '12632256',
    },
  },
  {
    headerName: 'NCPDP Claim Own',
    field: 'defNcpdpClaimOwnInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_120,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'DefNcpdpClaimOwnIndCheckBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    fillBackgroundColorCol: 'cfNcpdpClaimOwn',
    showBackgroundColor: true,
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.cfNcpdpClaimOwn?.toString() === '16756655',
      'yellow-legend': (params) =>
        params.data?.cfNcpdpClaimOwn?.toString() === '11534335',
      'pink-legend': (params) =>
        params.data?.cfNcpdpClaimOwn?.toString() === '11513855',
      'white-legend': (params) =>
        params.data?.cfNcpdpClaimOwn?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.cfNcpdpClaimOwn?.toString() === '12632256',
    },
  },
  {
    headerName: 'NCPDP Claim MB',
    field: 'defNcpdpClaimMbInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'DefNcpdpClaimMbIndCheckBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    fillBackgroundColorCol: 'cfNcpdpClaimMb',
    showBackgroundColor: true,
    cellClassRules: {
      'blue-legend': (params) =>
        params.data?.cfNcpdpClaimMb?.toString() === '16756655',
      'yellow-legend': (params) =>
        params.data?.cfNcpdpClaimMb?.toString() === '11534335',
      'pink-legend': (params) =>
        params.data?.cfNcpdpClaimMb?.toString() === '11513855',
      'white-legend': (params) =>
        params.data?.cfNcpdpClaimMb?.toString() === '16777215',
      'grey-legend': (params) =>
        params.data?.cfNcpdpClaimMb?.toString() === '12632256',
    },
  },
  {
    headerName: 'Mailed',
    field: 'invoiceMailedDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_160,
    sortingOrder: ['desc', 'asc'],
    comparator: dateComparator,
    cellRenderer: 'MailedDatePickerRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Uploaded',
    field: 'mostRecentInvoiceUploadDt',
    editable: false,
    sortable: true,
    comparator: dateComparator,
    cellRenderer: 'UploadedDatePickerRender',
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Downloaded',
    field: 'invoiceDownloadedDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_160,
    sortingOrder: ['desc', 'asc'],
    comparator: dateComparator,
    cellRenderer: 'DownloadedDatePickerRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Distributed',
    field: 'invoiceDistributedDt',
    editable: false,
    sortable: true,
    resizable: false,
    minWidth: Styles.Width_160,
    sortingOrder: ['desc', 'asc'],
    comparator: dateComparator,
    cellRenderer: 'DistributedDatePickerRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const InvoiceTableHead = [];
